import moment from "moment";
import { User } from "src/app/core/models/auth.models";
import { ProjectRequestModel } from "../../project-request/models/project-request.model";
import { ProjectModel } from "../../projects/models/project.model";

export enum AbsenceTypeUnity {
    HOUR = "HOUR",
    DAY = "DAY"
}

export class AbsenceTypeModel {
    public id: number;

    public absenceType: string;
    public unity: AbsenceTypeUnity;
    public acronym: string;
    public erpCode: string;
    public status: boolean;
    public justification: boolean;

    public createdAt: Date;
    public updatedAt: Date;

    constructor($obj?: any) {
        this.id = $obj ? $obj.id : '#new' + moment().valueOf();

        this.absenceType = $obj && $obj.absenceType ? $obj.absenceType : '';
        this.unity = $obj && $obj.unity ? $obj.unity : AbsenceTypeUnity.HOUR;
        this.acronym = $obj && $obj.acronym ? $obj.acronym : '';
        this.erpCode = $obj && $obj.erpCode ? $obj.erpCode : '';
        this.status = $obj && $obj.status;
        this.justification = $obj && $obj.justification;

        this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
        this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
    }

    setByForm(form: any) {
        this.absenceType = form.absenceType;
        this.unity = form.unity;
        this.acronym = form.acronym;
        this.erpCode = form.erpCode;
        this.status = form.status;
        this.justification = form.justification;

        return this;
    }

    toAPI() {
        return {
            absenceType: this.absenceType,
            unity: this.unity,
            acronym: this.acronym,
            erpCode: this.erpCode,
            status: this.status,
            justification: this.justification
        };
    }
}
